import { render, staticRenderFns } from "./ProductImage.pug?vue&type=template&id=844c4344&scoped=true&lang=pug&"
import script from "./ProductImage.js?vue&type=script&lang=js&"
export * from "./ProductImage.js?vue&type=script&lang=js&"
import style0 from "./ProductImage.sass?vue&type=style&index=0&id=844c4344&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844c4344",
  null
  
)

component.options.__file = "ProductImage.vue"
export default component.exports